// Shared image-upload drop-zone behaviour.
// Auto-initialises all [data-image-upload] containers on the page.

document.addEventListener("DOMContentLoaded", function () {
  var containers = document.querySelectorAll("[data-image-upload]");

  containers.forEach(function (container) {
    var dropzone = container.querySelector("[data-image-upload-dropzone]");
    var preview = container.querySelector("[data-image-upload-preview]");
    var previewImg = container.querySelector("[data-image-upload-preview-img]");
    var removeBtn = container.querySelector("[data-image-upload-remove]");
    var fileInput = container.querySelector("[data-image-upload-input]");
    var errorEl = container.querySelector("[data-image-upload-error]");

    var maxFileSizeMb = parseFloat(container.dataset.maxFileSizeMb) || 5;
    var maxFileSize = maxFileSizeMb * 1024 * 1024;

    if (!dropzone || !fileInput) return;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.classList.remove("tw-hidden");
      dropzone.classList.add("tw-border-red-500");
      dropzone.classList.remove("tw-border-grey-300");
      dropzone.classList.remove(
        "hover:tw-border-primary",
        "hover:tw-bg-blue-50",
      );
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = "";
      errorEl.classList.add("tw-hidden");
      dropzone.classList.remove("tw-border-red-500");
      dropzone.classList.add("tw-border-grey-300");
      dropzone.classList.add("hover:tw-border-primary", "hover:tw-bg-blue-50");
    }

    // Click the drop-zone to open file picker
    dropzone.addEventListener("click", function () {
      fileInput.click();
    });

    // On file selection validate then show preview
    fileInput.addEventListener("change", function () {
      var file = fileInput.files[0];
      if (!file) return;

      // 1. File type check
      if (!file.type.startsWith("image/")) {
        fileInput.value = "";
        showError("Please select an image file (PNG, JPG, or WebP).");
        return;
      }

      // 2. File size check
      if (file.size > maxFileSize) {
        fileInput.value = "";
        showError(
          "File is too large. Maximum size is " + maxFileSizeMb + " MB.",
        );
        return;
      }

      // 3. Dimension check (async) — load into a temporary Image
      var objectUrl = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(objectUrl);

        if (img.width < 600 || img.height < 300) {
          fileInput.value = "";
          showError("Image is too small. Minimum size is 600\u00d7300 pixels.");
          return;
        }

        // All checks passed — show preview
        clearError();
        var reader = new FileReader();
        reader.onload = function (e) {
          previewImg.src = e.target.result;
          dropzone.classList.add("tw-hidden");
          preview.classList.remove("tw-hidden");
        };
        reader.readAsDataURL(file);
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        fileInput.value = "";
        showError("Could not read image. Please try a different file.");
      };
      img.src = objectUrl;
    });

    // Remove button — clear file and revert to drop-zone
    if (removeBtn) {
      removeBtn.addEventListener("click", function () {
        fileInput.value = "";
        previewImg.src = "";
        preview.classList.add("tw-hidden");
        dropzone.classList.remove("tw-hidden");
        clearError();
      });
    }
  });
});
